module.exports = __webpack_public_path__ + "media/Audio16_e.953ee9cd.wav";